import * as React from 'react';
import { Modal } from '../../popup';
import { IWarehouseLocationDetails } from '../../../../../common/interfaces/warehouse';

// Styles
const s = require('./WarehousesLocations.css');

// Props
interface IWarehousesLocationsProps {
    onModalClose: () => void;
    customerType: string | null;
    showWarehouses: boolean;
    warehouses: IWarehouseLocationDetails[];
}

// Component
export const WarehousesLocations: React.StatelessComponent<IWarehousesLocationsProps> = props => {
    return (
        <Modal title="Contact information" show={props.showWarehouses} onClose={props.onModalClose} closeLabel="Close">
            <div>
                {props.warehouses
                    .filter(
                        whs =>
                            props.customerType === null ||
                            (props.customerType === 'PAC' && whs.pac) ||
                            (props.customerType === 'PBI' && whs.pbi) ||
                            (props.customerType === 'PBI+' && whs.pbiplus)
                    )
                    .map(warehouse => (
                        <div className={s.warehouse} key={warehouse.whsName + warehouse.address1}>
                            <h1>{warehouse.whsName}</h1>
                            {warehouse.address1 && <p>{warehouse.address1}</p>}
                            {warehouse.address2 && <p>{warehouse.address2}</p>}
                            {(warehouse.phone || warehouse.fax || warehouse.tollFreePhone) && <br />}
                            {warehouse.phone && (
                                <p>
                                    <strong>Tel: </strong>
                                    {warehouse.phone}
                                </p>
                            )}
                            {warehouse.fax && (
                                <p>
                                    <strong>Fax: </strong>
                                    {warehouse.fax}
                                </p>
                            )}
                            {warehouse.tollFreePhone && (
                                <p>
                                    <strong>Toll free: </strong>
                                    {warehouse.tollFreePhone}
                                </p>
                            )}
                        </div>
                    ))}
            </div>
        </Modal>
    );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/WarehousesLocations/WarehousesLocations.tsx